import { observer } from "mobx-react-lite";
import { AnalyticsHelper } from "core/lib/analytics";
import { SearchResultItem } from "core/models/search-result-item";

type SearchResultProps = {
  item: SearchResultItem;
}

//You can test this by using Malawi & Dedza
const getDirections = (item: SearchResultItem) => {
  const lat = item.coords.lat;
  const lng = item.coords.lng;

  const url = `https://www.google.com/maps/dir/?api=1&origin=Your+Location+&destination=${lat},${lng}`;
  return url;
}

const hasCoordinates = (item: SearchResultItem) => {
  return item.coords && item.coords.lat != 0 && item.coords.lng != 0;
}

const GetDirections = observer<SearchResultProps>((props) => {
  const { item } = props;
  if (!hasCoordinates(item)) {
    return null;
  }

  const { name, address } = item;

  const directionsUrl = getDirections(item);
  const directionsAnalytics = AnalyticsHelper.directions(name, address, directionsUrl)

  //TODO: Get Directions should be configurable / i18n.
  return (<a
    href={directionsUrl}
    target="_blank"
    {...directionsAnalytics}>
    <i className="icon-find-a-dealer" /> Get Directions
  </a>);
});

export default GetDirections;
